module.exports = __webpack_public_path__ + "static/img/banner_activity.c9924dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_activity.png
// module id = HCZX
// module chunks = 3